import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Input } from './input';
export function Instructions({ onSetFile, isDragging }) {
    const { t } = useTranslation();
    function handleSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            onSetFile(file);
        }
    }
    if (isDragging) {
        return _jsx("p", { className: "text-extrasmall text-neutral-700", children: t('upload_file.drop_file') });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Input, { onSelectFile: handleSelectFile }), _jsx("p", { className: "text-extrasmall text-neutral-700", children: t('upload_file.drag_file') })] }));
}
